module.exports = __webpack_public_path__ + "static/media/blueAiLoader.073ade62.gif";